// extracted by mini-css-extract-plugin
module.exports = {"Credits":"Credits_Credits____69J","CreditsDivider":"Credits_CreditsDivider__cgdF3"};